__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => (typeof console !== "undefined" && console.warn && console.warn(msg));
	var uniqueName = "portal-ui";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@codat/analytics", "2.0.1", () => (Promise.all([__webpack_require__.e(188), __webpack_require__.e(259), __webpack_require__.e(676)]).then(() => (() => (__webpack_require__(3188))))));
			register("@codat/client-cookie-manager", "3.15.0", () => (Promise.all([__webpack_require__.e(872), __webpack_require__.e(995), __webpack_require__.e(259)]).then(() => (() => (__webpack_require__(4995))))));
			register("react-dom", "18.2.0", () => (Promise.all([__webpack_require__.e(406), __webpack_require__.e(259)]).then(() => (() => (__webpack_require__(1406))))));
			register("react-router-dom-v5-compat", "6.23.0", () => (Promise.all([__webpack_require__.e(441), __webpack_require__.e(259), __webpack_require__.e(429)]).then(() => (() => (__webpack_require__(3441))))));
			register("react-router-dom", "5.3.4", () => (Promise.all([__webpack_require__.e(951), __webpack_require__.e(259)]).then(() => (() => (__webpack_require__(5951))))));
			register("react", "18.3.1", () => (__webpack_require__.e(271).then(() => (() => (__webpack_require__(5271))))));
			initExternal(1773);
			initExternal(7905);
			initExternal(9186);
			initExternal(6978);
			initExternal(8116);
			initExternal(3941);
			initExternal(8018);
			initExternal(2963);
			initExternal(1582);
			initExternal(4762);
			initExternal(401);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};